export default {
    loggedIn: false,
    currentUser: {},
    userProfile: {},
    lastPos: null,
    state: null
};